import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 4rem)',
    padding: '0.75rem 0 8rem 0',
    fontSize: theme.size.sm,
    width: '120px',
    position: 'fixed',
    backgroundColor: '#F0F0F0'
  },

  logo: {
    marginBottom: '0.5rem',
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'center'
  },

  icon: {
    fontSize: theme.size.xl
  }
}))

export default useStyles
